import { beam } from '@styles/colors/themes';
import styled from 'styled-components';
import { ButtonClick } from '../CustomFieldDetails/CustomFieldDetails.styles';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 466px;
  max-height: 90vh;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }

  .form-body {
    display: grid;
    grid-template-rows: auto minmax(50%, 100%) auto;
    row-gap: 28px;
    max-height: calc(90vh - 48px);
  }
  .form-body_inputs > div {
    /* Fix scrollArea wrapper */
    table-layout: fixed;
    width: 100%;
  }

  .no-margin-padding {
    padding: 0;
    margin: 0;
  }
  .no-margin-top {
    margin-top: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #474d66;
  font-size: 14px;
  font-weight: 400;

  &.headTitle {
    color: #161a30;
    font-size: 18px;
    font-weight: 600;
  }
`;

export const Close = styled.div`
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 5px;
  height: 32px;
  width: 32px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Label = styled.div`
  font-size: 12px;
  color: #474d66;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 16px;
  &.optional {
    color: #8f95b2;
  }
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  display: flex;
  width: 100%;
  height: 36px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 12px;
  margin-bottom: 8px;
  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;

export const Error = styled.div`
  color: #d14343;
  font-size: 12px;
  margin-top: 8px;
`;

export const Textarea = styled.textarea<IInput>`
  display: flex;
  width: 100%;
  height: 64px;
  max-height: 140px;
  min-height: 64px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 12px;

  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;

export const GridDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const ShortClose = styled.img`
  cursor: pointer;
  height: 10px;
  display: flex;
  width: 10px;
  z-index: 999;
  color: #8f95b2 !important;
`;

export const ButtonPlus = styled(ButtonClick)`
  min-width: unset;
  max-width: unset;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  width: 36px;
  height: 36px;
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 418px;
`;

export const YesNo = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-left: 12px;
  margin-right: 16px;
  line-height: 20px;
  /* identical to box height, or 143% */

  /* Neutral/N800 (Text Normal) */
  color: #474d66;
`;

export const Line = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
  padding-bottom: 24px;
  align-items: flex-end;
  align-self: end;
  justify-self: end;
  bottom: 0;
  right: 0;
`;

export const Confirm = styled.button`
  height: 36px;
  padding: 0 16px;
  color: #fff;
  font-weight: 500;
  background: #1371fe;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;

  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
`;

export const Plus = styled.img`
  cursor: pointer;
  align-self: center;
  justify-self: center;
  display: flex;
  height: 12px;
  width: 12px;
  color: #8f95b2 !important;
`;
export { ButtonClick };
